import React from 'react'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

function SectionMargin() {
    return (
        <div css={css`margin:4em 0`}>
            
        </div>
    )
}

export default SectionMargin
